/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Document_Source_ExternalInputs */

const en_orders_document_source_external = /** @type {(inputs: Orders_Document_Source_ExternalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`External`)
};

const es_orders_document_source_external = /** @type {(inputs: Orders_Document_Source_ExternalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Externo`)
};

/**
* | output |
* | --- |
* | "External" |
*
* @param {Orders_Document_Source_ExternalInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_document_source_external = /** @type {((inputs?: Orders_Document_Source_ExternalInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Document_Source_ExternalInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_document_source_external(inputs)
	return es_orders_document_source_external(inputs)
});